/**
 * Tài liệu hướng dẫn sử dụng AGADS (BOSS 20/10/2026) — file PDF tĩnh trong `frontend/public/tai-lieu/`,
 * mọi người dùng đều tải được, không phụ thuộc công ty hay quyền. Bản nguồn để dựng lại PDF:
 * `docs/huong-dan-su-dung/`.
 *
 * Đổi nội dung PDF thì tăng `PHIEN_BAN_TAI_LIEU` để trình duyệt không giữ bản cũ.
 */
export const PHIEN_BAN_TAI_LIEU = '2.1';

export const DUONG_TAI_LIEU = `/tai-lieu/AGADS-Huong-dan-su-dung.pdf?v=${PHIEN_BAN_TAI_LIEU}`;

export const TEN_FILE_TAI_LIEU = `AGADS-Huong-dan-su-dung-v${PHIEN_BAN_TAI_LIEU}.pdf`;
